import { useCallback } from 'react';

import { useConvertContext } from '../contexts/ConvertContext';

import { type ConvertGoalKeys } from '../helpers/convertGoalKeys';
import { PAGE } from '../helpers/pages';

const useLeadTracking = (args: { page: PAGE }) => {
  const { page } = args;

  const { sdkContext } = useConvertContext({ page });

  const trackLead = useCallback(
    (goalKey: ConvertGoalKeys) => {
      if (sdkContext) {
        sdkContext.trackConversion(goalKey, {
          ruleData: {
            action: 'sent',
          },
        });
      }
    },
    [sdkContext],
  );

  return {
    trackLead,
  };
};

export { useLeadTracking };
